import { render } from "./PaymentCenterLayout.vue?vue&type=template&id=79de35c6&scoped=true"
import script from "./PaymentCenterLayout.vue?vue&type=script&lang=js"
export * from "./PaymentCenterLayout.vue?vue&type=script&lang=js"

import "./PaymentCenterLayout.vue?vue&type=style&index=0&id=79de35c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79de35c6"]])

export default __exports__